import React, { PureComponent } from 'react';
import CheckBox from '../../../../components/svg/CheckBox';
import { getHexColorString, getOpacityFromRgba } from '../../../../helpers/helpers';
import { ValueChangedForFieldFunc } from '../../../formeditor-types';
import FieldWrapper from './FieldWrapper';

export interface CheckBoxGroupFieldProps {
  valueUpdated: ValueChangedForFieldFunc;
  id?: string;
  fieldId?: string;
  x?: number;
  y?: number;
  w?: number;
  h?: number;
  align?: string;
  foregroundColor: TypeMePlease;
  backgroundColor: TypeMePlease;
  displayType?: number;
  maxSize?: number;
  padding?: number;
  checkBoxValue?: string;
  multiSelect: boolean;
  editable: boolean;
  value?: string;
}

export default class CheckBoxGroupField extends PureComponent<CheckBoxGroupFieldProps, TypeMePlease> {
  constructor(props) {
    super(props);

    this.mouseDown = this.mouseDown.bind(this);
  }

  mouseDown() {
    let selectedValues = this.props.value ? this.props.value.split(';') : [];
    const selectedIndex = selectedValues.indexOf(this.props.checkBoxValue);
    if (selectedIndex === -1) {
      // If the value hasn't already been selected
      if (this.props.multiSelect) {
        selectedValues.push(this.props.checkBoxValue);
      } else {
        selectedValues = [this.props.checkBoxValue];
      }
    } else {
      //remove it from the selected array
      selectedValues.splice(selectedIndex, 1);
    }

    this.props.valueUpdated({ value: selectedValues.join(';') });
  }

  render() {
    let checkbox = null;
    const selectedValues = this.props.value ? this.props.value.split(';') : [];
    if (selectedValues.indexOf(this.props.checkBoxValue) > -1) {
      checkbox = (
        <CheckBox
          maxSize={this.props.maxSize}
          padding={this.props.padding}
          foregroundColor={getHexColorString(this.props.foregroundColor)}
          foregroundColorOpacity={getOpacityFromRgba(this.props.foregroundColor)}
          displayType={this.props.displayType}
          width={this.props.w}
          height={this.props.h}
          align={this.props.align}
        />
      );
    }
    return (
      <FieldWrapper
        onMouseDown={this.mouseDown}
        x={this.props.x}
        y={this.props.y}
        w={this.props.w}
        h={this.props.h}
        backgroundColor={this.props.backgroundColor}
        editable={this.props.editable}
        id={this.props.id}
        fieldId={this.props.fieldId}
      >
        {checkbox}
      </FieldWrapper>
    );
  }
}
